import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminKycBack = _resolveComponent("AdminKycBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_AdminKycBack, {
      title: "Загрузка документов",
      onBack: _ctx.handleBack
    }, null, 8, ["onBack"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('form'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('form-block'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('form-title'))
        }, _toDisplayString(_ctx.$t("Подтверждающие документы")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-fields'))
        }, [
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-registration-company'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Сертификат о")) + " ", 1),
              _hoisted_1,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("регистрации")) + " ", 1),
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("компании")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-regulation'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Устав")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-list-of-shareholders'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Список акционеров")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-license'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Лицензия")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-check-addresses'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Подтверждение")) + " ", 1),
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("адреса")) + " ", 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("регистрации")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-sow'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Доказательства")) + " ", 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("источника дохода")) + " ", 1),
              _hoisted_9,
              _createTextVNode(" SoW ")
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-sof'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Доказательства")) + " ", 1),
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("источника средств")) + " ", 1),
              _hoisted_11,
              _createTextVNode(" SoF ")
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-inn'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Свидетельство")) + " ", 1),
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("ИНН")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-record-sheet'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Лист Записи")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-create'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Решение о создании/")) + " ", 1),
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Учредительный")) + " ", 1),
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-update'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Изменения в")) + " ", 1),
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("учредительные")) + " ", 1),
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("документы")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-purpose'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("О назначении")) + " ", 1),
              _hoisted_17,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("единоличного")) + " ", 1),
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("исполнительного")) + "... ", 1),
              _hoisted_19
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-finance'],
            "is-readonly": true,
            "is-padding": false,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Финансовая")) + " ", 1),
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("отчетность")) + " ", 1),
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("(за год/за квартал)")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-example'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Карточка образцов")) + " ", 1),
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("подписей и печатей")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('form-block'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('form-title'))
        }, _toDisplayString(_ctx.$t("Cоглашения")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-fields'))
        }, [
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-document'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
              _hoisted_23,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("юридического лица")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-beneficiary'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("бенефициарного")) + " ", 1),
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("владельца")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-broker'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"]),
          _createVNode(_component_SharedUpload, {
            class: _normalizeClass(_ctx.b('upload')),
            document: _ctx.documents['kyb-documents-declaration'],
            "is-readonly": true,
            "is-download": true
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Декларация")) + " ", 1),
              _hoisted_27,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("о рисках")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"])
        ], 2)
      ], 2),
      (_ctx.files.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('form-block'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('form-title'))
            }, _toDisplayString(_ctx.$t("Документы для верификации")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-fields'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('form-upload')),
                  document: file,
                  "is-readonly": true,
                  "is-download": true
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(file.name), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "document"]))
              }), 128))
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}